import { Toggle } from '@sonnen/web-ui';
import { useAppContext } from '../../AppContext/AppContext';
import { useTranslation } from '../../i18n/i18n';
import { useOfferContext } from '../../OfferContext/OfferContext';
import { ModuleName } from '../../types';
import { moduleAvailable } from '../../utils/utils';

type ModuleCardProps = {
  name: ModuleName;
};

export const ModuleToggle = ({ name }: ModuleCardProps) => {
  const { t } = useTranslation();
  const { offer, offerLoading } = useOfferContext();
  const { modules, toggleModule } = useAppContext();
  const selected = modules.has(name);
  const available = moduleAvailable(offer, name);
  const { configurationWithBatteryOptimizationModule } = offer?.energyDynamic ?? {};

  const onChange = () => toggleModule(name);
  return (
    <Toggle
      disabled={offerLoading || !available || !configurationWithBatteryOptimizationModule}
      value={selected && available && Boolean(configurationWithBatteryOptimizationModule)}
      onChange={onChange}
      dataTestId={`${name}-toggle`}
      ariaLabel={t(`modules.${selected ? 'included' : 'excluded'}`)}
    />
  );
};
